module.exports = __webpack_public_path__ + "img/PromtionSystem.89f8a7fd.png";